const rankingItems = [
  { rank: 1, title: '剑与魔法录', category: '热血冒险', heat: '98.6', trend: 'up' },
  { rank: 2, title: '甜蜜陷阱', category: '恋爱甜宠', heat: '96.3', trend: 'up' },
  { rank: 3, title: '暗夜侦探', category: '悬疑推理', heat: '94.1', trend: 'up' },
  { rank: 4, title: '异界召唤师', category: '奇幻异世界', heat: '92.8', trend: 'stable' },
  { rank: 5, title: '仙途问道', category: '古风仙侠', heat: '90.5', trend: 'up' },
  { rank: 6, title: '都市夜话', category: '都市生活', heat: '88.2', trend: 'down' },
  { rank: 7, title: '机甲纪元', category: '科幻未来', heat: '86.7', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">人气榜单</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">综合热度、讨论与更新频率的实时漫画排行榜</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 px-5 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-50/50 transition-colors duration-200 cursor-pointer"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.category}</p>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                {item.trend === 'up' && (
                  <span className="inline-flex items-center gap-0.5 text-xs font-medium text-emerald-600">
                    <i className="ri-arrow-up-s-line"></i>
                  </span>
                )}
                {item.trend === 'down' && (
                  <span className="inline-flex items-center gap-0.5 text-xs font-medium text-red-500">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                )}
                {item.trend === 'stable' && (
                  <span className="inline-flex items-center gap-0.5 text-xs font-medium text-foreground-400">
                    <i className="ri-subtract-line"></i>
                  </span>
                )}
              </div>

              <div className="text-right flex-shrink-0 w-16">
                <div className="text-sm font-bold text-foreground-800">{item.heat}</div>
                <div className="text-[10px] text-foreground-400">热度值</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}